import { URL } from './endpoints'
import { submitToApi } from 'awsApi'

export const ACTIONS = {
    GET_TICKETS: {
        START: 'GET_TICKETS START',
        SUCCESS: 'GET_TICKETS SUCCESS',
        FAILURE: 'GET_TICKETS FAILURE',
    },
    CLOSE_TICKET: {
        START: 'CLOSE_TICKET START',
        SUCCESS: 'CLOSE_TICKET SUCCESS',
        FAILURE: 'CLOSE_TICKET FAILURE',
    },
}

export const getTickets = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_TICKETS.START, })
    try {
        const { payload } = await submitToApi({
            path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_GETTRANSACTIONS,
            url: URL.EMAIL_SUPPORT.BASE,
        })
        dispatch({ type: ACTIONS.GET_TICKETS.SUCCESS, tickets: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_TICKETS.FAILURE, error })
    }
}

export const closeTicket =
    (ticket, from, name, callback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.CLOSE_TICKET.START, ticket })
        try {
            const { message } = await submitToApi({
                body: { ...ticket, userName: name },
                method: 'PUT',
                path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_CLOSETICKET,
                query: { from },
                url: URL.EMAIL_SUPPORT.BASE,
            })
            dispatch({ type: ACTIONS.CLOSE_TICKET.SUCCESS, ticket })
            callback(message)
        } catch (error) {
            dispatch({ type: ACTIONS.CLOSE_TICKET.FAILURE, error })
            callback(`Something went wrong with closing ticket. Error: ${error}`)
        }
    }
